import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";

export function CancellationSuccess({
  closeModal,
  title,
}: {
  closeModal: () => void;
  title: string;
}) {
  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      <CancelButtons
        negativeText={null}
        onNegative={null}
        positiveText="Got it"
        onPositive={closeModal}
      />
    </div>
  );
}
